<template>
  <div>
    <a-tree
      show-line
      class="draggable-tree"
      :replaceFields="{children:'children', title:'name', key:'id'}"
      :defaultSelectedKeys="defaultSelectedKeys"
      :defaultExpandedKeys="defaultSelectedKeys"
      :selectedKeys="selectedKeys"
      defaultExpandAll
      :tree-data="treeData"
      @select="onDrop" >
      <a-icon slot="child" type="file-text" />
    </a-tree>
  </div>
</template>

<script>
  export default {
    props:{
      treeData:{
        type:Array,
        default:()=>{
          return []
        }
      },
    },
    data(){
      return {
        defaultSelectedKeys:[],
        selectedKeys:[],
      }
    },
    created() {
      this.getMouted()
    },
    
    methods: {
      onDrop(val,e){
        let temObj={
          id:val[0],//节点ID
          icon:e.node.icon,
        }
        if(val.length!==0){
          this.selectedKeys = val
          this.$emit('getTreeNode', temObj)
        }
        
      },
      getMouted(){
        this.nodeDefault(this.treeData[0].id);//默认选中第一个节点
        // this.emitNodeVale(this.treeData[0].id,this.treeData[0].name);//传值
      },
      
      nodeDefault(key){
        this.defaultSelectedKeys = [key]
        this.selectedKeys = [key]
      },
    
    },
  }
</script>

<style lang="less" scoped>
/deep/.ant-tree.ant-tree-show-line li:not(:last-child)::before{
    border-left: 0px solid #d9d9d9;
}
/deep/.ant-tree>li>.ant-tree-node-content-wrapper{
  color: #333;
}

</style>